// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/rasthuelsenbaugruppe/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteRasthuelsenbaugruppeDE: PageEntry = {
  id: "example.produkte-rasthuelsenbaugruppe",
  locale: "de",
  slug: "produkte/rasthuelsenbaugruppe",
  seo: {
    title: "Rasthülsenbaugruppe | Dietz GmbH",
    description: "Verrastung von Schaltstellungen im Interieurbereich",
  },
  type: "post",
  h1: "Rasthülsenbaugruppe",
  intro: "Verrastung von Schaltstellungen im Interieurbereich",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_rasthuelsen.jpg", alt: "Rasthülsen-Baugruppe", width: 1280, height: 1024 },
    { kind: "paragraph", text: "Ansprechende Haptik und Geräuschbildung während der Betätigung. Schwierigkeit hierbei ist die Verbindung zwischen Feder und Kunststoff- oder Metallhülsen sicherzustellen." }
  ],
};
